import React, { useMemo } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { LLM_TYPES } from '@proximl-internal/mcp-core/enum';

import getLlmTypeLabel from '@/util/getLlmTypeLabel';

export default function TypeField({
  value,
  onChange,
  disabled = false,
  error = false,
}) {
  const types = useMemo(() => Object.values(LLM_TYPES), []);

  return (
    <FormControl fullWidth disabled={disabled} error={error}>
      <InputLabel id='endpoint-llm-type-label'>Type</InputLabel>
      <Select
        labelId='endpoint-llm-type-label'
        label='Type'
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
      >
        {types.map((llm_type) => (
          <MenuItem key={llm_type} value={llm_type}>
            {getLlmTypeLabel(llm_type)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
